import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {ActivatedRoute, Router} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';
import {first} from 'rxjs/operators';
import {MerchantService} from '../../../services/merchant.service';

@Component({
    selector: 'app-merchant-add-edit',
    templateUrl: './merchant-add-edit.component.html',
    styleUrls: ['./merchant-add-edit.component.scss']
})
export class MerchantAddEditComponent implements OnInit {

    form: FormGroup;
    submitted = false;
    loading = false;
    merchant: any = {};
    id: number;

    constructor(
        private formBuilder: FormBuilder,
        private toastrService: ToastrService,
        private merchantService: MerchantService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private spinner: NgxSpinnerService,
    ) {
    }

    ngOnInit() {
        this.form = this.formBuilder.group({
            name: ['', Validators.required],
            ruc: ['', [Validators.required, Validators.maxLength(11), Validators.minLength(11)]],
            description: [''],
            status: ['1', Validators.required],
        });

        this.id = this.activatedRoute.snapshot.params['id'];

        if (this.id) {
            this.spinner.show();
            this.merchantService.getById(this.id).pipe(first()).subscribe(response => {
                this.spinner.hide();
                this.form.patchValue(response.data);
                this.merchant = response.data;
            }, error => {
                this.spinner.hide();
                this.router.navigate(['']);
            });
        }
    }

    get f() {
        return this.form.controls;
    }

    sendForm(): void {
        this.submitted = true;
        if (!this.form.valid) {
            return;
        }
        this.loading = true;
        let merchant: any = this.form.value;
        if (this.id != null) {
            merchant.id = this.id;
            this.merchantService.update(merchant)
                .pipe(first())
                .subscribe(response => {
                    this.loading = false;
                    this.toastrService.success(response.message, 'Éxito!');
                    this.router.navigate(['/merchants']);
                }, error => {
                    this.toastrService.error(error, 'Error');
                    this.loading = false;
                });
        } else {
            this.merchantService.store(merchant)
                .pipe(first())
                .subscribe(response => {
                    this.loading = false;
                    this.toastrService.success(response.message, 'Éxito!');
                    this.router.navigate(['/merchants']);
                }, error => {
                    this.toastrService.error(error, 'Error');
                    this.loading = false;
                });
        }
    }

}
